import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

export const PasswordStrengthLinearProgress = styled(LinearProgress, {
    shouldForwardProp: (prop) => prop !== "strength"
})(({ theme, strength }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200]
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: strength < 60 ? 'red' : strength >= 60 && strength <= 70 ? 'orange' : 'limegreen',
    },
}));